<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 1125 638" style="enable-background:new 0 0 1125 638;" xml:space="preserve">
  <g class="father-name father-name-3" :style="{opacity: name3 === ' ' ? '0' : '1'}">
    <g class="father-name-tag-3">
      <polygon class="st0" points="274.1,493.2 273.4,492.4 352.7,424.4 353,424.6 437.1,488.8 436.5,489.6 352.7,425.6"/>
      <rect x="268.2" y="484.9" transform="matrix(0.9999 -1.134164e-02 1.134164e-02 0.9999 -5.8023 4.0659)" class="st1"
            width="174.7" height="57.3"/>
      <ellipse transform="matrix(0.1162 -0.9932 0.9932 0.1162 -247.5076 707.4203)" class="st2" cx="273.8" cy="492.8"
               rx="2" ry="2"/>
      <ellipse transform="matrix(0.1162 -0.9932 0.9932 0.1162 -101.3906 866.7195)" class="st2" cx="436.3" cy="490.3"
               rx="2" ry="2"/>
      <g>
        <path class="st3" d="M274.5,533.7c0,0,1.8,0,5-0.1c3.2,0,7.7-0.1,13.1-0.2c5.4,0,11.7-0.1,18.5-0.2c6.8,0,14-0.1,21.2-0.1
          c7.2,0,14.4,0,21.2,0c6.8,0,13.1,0.1,18.5,0.1c5.4,0.1,9.9,0.1,13.1,0.2c3.2,0.1,5,0.1,5,0.1s-1.8,0-5,0.1
          c-3.2,0-7.7,0.1-13.1,0.2c-5.4,0-11.7,0.1-18.5,0.2c-6.8,0-14,0.1-21.2,0.1c-7.2,0-14.4,0-21.2,0c-6.8,0-13.1-0.1-18.5-0.1
          c-5.4-0.1-9.9-0.1-13.1-0.2C276.3,533.7,274.5,533.7,274.5,533.7z"/>
        <path class="st3" d="M307.7,529.5c0,0,1.8,0,5-0.1c3.2,0,7.7-0.1,13.1-0.2c5.4,0,11.7-0.1,18.5-0.2c6.8,0,14-0.1,21.2-0.1
          c7.2,0,14.4,0,21.2,0c6.8,0,13.1,0.1,18.5,0.1c5.4,0.1,9.9,0.1,13.1,0.2c3.2,0.1,5,0.1,5,0.1s-1.8,0-5,0.1
          c-3.2,0-7.7,0.1-13.1,0.2c-5.4,0-11.7,0.1-18.5,0.2c-6.8,0-14,0.1-21.2,0.1c-7.2,0-14.4,0-21.2,0c-6.8,0-13.1-0.1-18.5-0.1
          c-5.4-0.1-9.9-0.1-13.1-0.2C309.5,529.5,307.7,529.5,307.7,529.5z"/>
        <path class="st3" d="M295.7,494.5c0,0,1.2,0,3.2-0.1c2,0,4.9-0.1,8.4-0.2c3.5,0,7.6-0.1,11.9-0.2c4.4,0,9-0.1,13.7-0.1
          c4.7,0,9.3,0,13.7,0.1c4.4,0,8.4,0.1,11.9,0.1c3.5,0,6.4,0.1,8.4,0.2c2,0.1,3.2,0.1,3.2,0.1s-1.2,0-3.2,0.1c-2,0-4.9,0.1-8.4,0.2
          c-3.5,0-7.6,0.1-11.9,0.2c-4.4,0-9,0.1-13.7,0.1c-4.7,0-9.3,0-13.7-0.1c-4.4,0-8.4-0.1-11.9-0.1c-3.5,0-6.4-0.1-8.4-0.2
          C296.9,494.5,295.7,494.5,295.7,494.5z"/>
        <path class="st3" d="M268.4,506.6c0,0,0.8,0,2.1-0.1c1.4,0,3.3-0.2,5.6-0.2c2.3-0.1,5.1-0.2,8-0.2c2.9,0,6-0.1,9.1-0.1
          c3.1,0,6.2,0,9.1,0c2.9,0,5.6,0.1,8,0.1c2.3,0,4.3,0.1,5.6,0.1c1.4,0.1,2.1,0.1,2.1,0.1s-0.8,0-2.1,0.1c-1.4,0-3.3,0.2-5.6,0.2
          c-2.3,0.1-5.1,0.2-8,0.2c-2.9,0-6,0.1-9.1,0.1c-3.1,0-6.2,0-9.1,0c-2.9,0-5.6-0.1-8-0.1c-2.3,0-4.3-0.1-5.6-0.1
          C269.2,506.6,268.4,506.6,268.4,506.6z"/>
      </g>
      <g class="father-name-text father-name-text-3">
        <foreignObject x="268.2" y="484.9" width="174.7" height="57.3"
                       transform="matrix(0.9999 -1.134164e-02 1.134164e-02 0.9999 -5.8023 4.0659)">
          <div class="father-name-container">
            <name-container
              :text="name3"
              :chars-limit-one="16"
              :chars-limit-two="19"
              :chars-limit-three="22"
              size-three="0.6em"></name-container>
          </div>
        </foreignObject>
      </g>
    </g>
    <g class="father-name-star father-name-star-3">
      <path class="st4" d="M355.8,417l0.8,6c0,0.2,0.2,0.5,0.4,0.6l5.4,2.8c0.6,0.3,0.5,1.1,0,1.3l-5.5,2.6c-0.2,0.1-0.4,0.3-0.4,0.6
        l-1,6c-0.1,0.6-0.9,0.8-1.3,0.4l-4.2-4.4c-0.2-0.2-0.4-0.3-0.7-0.2l-6,0.9c-0.6,0.1-1.1-0.6-0.8-1.1l2.9-5.3
        c0.1-0.2,0.1-0.5,0-0.7l-2.8-5.4c-0.3-0.6,0.2-1.2,0.8-1.1l6,1.1c0.2,0,0.5,0,0.7-0.2l4.3-4.3C355,416.1,355.7,416.4,355.8,417z"
      />
      <g>
        <path class="st5" d="M362.4,426.4l-0.8-0.4l-5.4,2.5c-0.2,0.1-0.4,0.3-0.4,0.6l-1,6c-0.1,0.6-0.9,0.8-1.3,0.4l-4.2-4.4
          c-0.2-0.2-0.4-0.3-0.7-0.2l-5.7,0.9l-0.4,0.8c-0.3,0.5,0.2,1.2,0.8,1.1l6-0.9c0.2,0,0.5,0,0.7,0.2l4.2,4.4
          c0.4,0.5,1.2,0.2,1.3-0.4l1-6c0-0.2,0.2-0.5,0.4-0.6l5.5-2.6C363,427.4,363,426.6,362.4,426.4z"/>
      </g>
      <path class="st6" d="M354.5,417.8c0,0-0.1,0.2-0.4,0.6c-0.3,0.3-0.6,0.7-1,1.1c-0.4,0.4-0.8,0.7-1.2,1c-0.3,0.2-0.6,0.4-0.6,0.4
        s0.1-0.2,0.4-0.6c0.3-0.3,0.6-0.7,1-1.1c0.4-0.4,0.8-0.7,1.2-1C354.2,418,354.5,417.8,354.5,417.8z"/>
      <path class="st6" d="M348.4,422c0,0-0.3,0-0.7,0c-0.4,0-1-0.1-1.5-0.2c-0.5-0.1-1.1-0.3-1.4-0.4c-0.4-0.2-0.6-0.3-0.6-0.3
        s0.3,0,0.7,0c0.4,0,1,0.1,1.5,0.2c0.5,0.1,1.1,0.3,1.4,0.4C348.1,421.8,348.4,422,348.4,422z"/>
      <path class="st6" d="M346.8,427.4c0,0-0.1,0.3-0.3,0.6c-0.2,0.4-0.5,0.8-0.8,1.3c-0.3,0.4-0.7,0.9-0.9,1.2
        c-0.3,0.3-0.5,0.5-0.5,0.5s0.1-0.3,0.3-0.6c0.2-0.4,0.5-0.8,0.8-1.3c0.3-0.4,0.7-0.9,0.9-1.2C346.6,427.6,346.8,427.4,346.8,427.4
        z"/>
    </g>
  </g>
    <g class="father-name father-name-2" :style="{opacity: name2 === ' ' ? '0' : '1'}">
    <g class="father-name-tag-2">
      <polygon class="st10" points="565.7,387.7 497.3,307.5 406.2,356.9 405.7,356 497.5,306.2 566.4,387"/>
      <rect x="394.2" y="365.4" transform="matrix(0.9798 0.1998 -0.1998 0.9798 88.4247 -88.251)" class="st4"
            width="174.7" height="57.3"/>
      <ellipse transform="matrix(0.323 -0.9464 0.9464 0.323 -62.5408 625.496)" class="st10" cx="406" cy="356.5" rx="2"
               ry="2"/>
      <ellipse transform="matrix(0.323 -0.9464 0.9464 0.323 16.6233 797.9241)" class="st10" cx="566.1" cy="387.3" rx="2"
               ry="2"/>
      <g class="st12">
        <path class="st7" d="M398.1,396.6c0,0,1.8,0.3,4.9,0.9c3.1,0.6,7.5,1.5,12.8,2.6c5.3,1.1,11.5,2.4,18.1,3.7
          c6.6,1.4,13.7,2.9,20.7,4.4c7,1.5,14.1,3.1,20.7,4.5c6.6,1.5,12.7,2.8,18,4c5.3,1.2,9.7,2.2,12.7,2.9c3.1,0.7,4.8,1.1,4.8,1.1
          s-1.8-0.3-4.9-0.9c-3.1-0.6-7.5-1.5-12.8-2.6c-5.3-1.1-11.5-2.4-18.1-3.7c-6.6-1.4-13.7-2.9-20.7-4.4c-7-1.5-14.1-3.1-20.7-4.5
          c-6.6-1.5-12.7-2.8-18-4c-5.3-1.2-9.7-2.2-12.7-2.9C399.8,397,398.1,396.6,398.1,396.6z"/>
        <path class="st7" d="M431.4,399.5c0,0,1.8,0.3,4.9,0.9c3.1,0.6,7.5,1.5,12.8,2.6c5.3,1.1,11.5,2.4,18.1,3.7
          c6.6,1.4,13.7,2.9,20.7,4.4c7,1.5,14.1,3.1,20.7,4.5c6.6,1.5,12.7,2.8,18,4c5.3,1.2,9.7,2.2,12.7,2.9c3.1,0.7,4.8,1.1,4.8,1.1
          s-1.8-0.3-4.9-0.9c-3.1-0.6-7.5-1.5-12.8-2.6c-5.3-1.1-11.5-2.4-18.1-3.7c-6.6-1.4-13.7-2.9-20.7-4.4c-7-1.5-14.1-3.1-20.7-4.5
          c-6.6-1.5-12.7-2.8-18-4c-5.3-1.2-9.7-2.2-12.7-2.9C433.2,399.9,431.4,399.5,431.4,399.5z"/>
        <path class="st7" d="M427.1,362.7c0,0,1.1,0.2,3.2,0.6c2,0.4,4.9,0.9,8.3,1.6c3.4,0.7,7.4,1.5,11.7,2.4c4.3,0.9,8.8,1.9,13.4,2.8
          c4.5,1,9.1,2,13.4,2.9c4.3,0.9,8.2,1.9,11.6,2.7c3.4,0.8,6.2,1.5,8.2,2c2,0.5,3.1,0.8,3.1,0.8s-1.1-0.2-3.2-0.6
          c-2-0.4-4.9-0.9-8.3-1.6c-3.4-0.7-7.4-1.5-11.7-2.4c-4.3-0.9-8.8-1.9-13.4-2.8c-4.5-1-9.1-2-13.4-2.9c-4.3-0.9-8.2-1.9-11.6-2.7
          c-3.4-0.8-6.2-1.5-8.2-2C428.2,363,427.1,362.7,427.1,362.7z"/>
        <path class="st7" d="M397.8,368.8c0,0,0.8,0.1,2.1,0.3c1.3,0.2,3.3,0.5,5.6,1c2.3,0.4,5,0.9,7.8,1.5c2.9,0.6,5.9,1.2,9,1.8
          c3,0.7,6.1,1.3,8.9,1.9c2.9,0.6,5.5,1.3,7.8,1.8c2.3,0.5,4.2,1,5.5,1.3c1.3,0.3,2.1,0.5,2.1,0.5s-0.8-0.1-2.1-0.3
          c-1.3-0.2-3.3-0.5-5.6-1c-2.3-0.4-5-0.9-7.8-1.5c-2.9-0.6-5.9-1.2-9-1.8c-3-0.7-6.1-1.3-8.9-1.9c-2.9-0.6-5.5-1.3-7.8-1.8
          c-2.3-0.5-4.2-1-5.5-1.3C398.6,369,397.8,368.8,397.8,368.8z"/>
      </g>
      <g class="father-name-text father-name-text-2">
        <foreignObject x="394.2" y="365.4" transform="matrix(0.9798 0.1998 -0.1998 0.9798 88.4247 -88.251)"
                       width="174.7" height="57.3">
          <div class="father-name-container">
            <name-container
              :text="name2"
              :chars-limit-one="16"
              :chars-limit-two="19"
              :chars-limit-three="22"
              size-three="0.6em"></name-container>
          </div>
        </foreignObject>
      </g>
    </g>
      <g class="father-name-star father-name-star-2">
      <path class="st4" d="M501.2,296.3l0.8,6c0,0.2,0.2,0.5,0.4,0.6l5.4,2.8c0.6,0.3,0.5,1.1,0,1.3l-5.5,2.6c-0.2,0.1-0.4,0.3-0.4,0.6
        l-1,6c-0.1,0.6-0.9,0.8-1.3,0.4l-4.2-4.4c-0.2-0.2-0.4-0.3-0.7-0.2l-6,0.9c-0.6,0.1-1.1-0.6-0.8-1.1l2.9-5.3
        c0.1-0.2,0.1-0.5,0-0.7l-2.8-5.4c-0.3-0.6,0.2-1.2,0.8-1.1l6,1.1c0.2,0,0.5,0,0.7-0.2l4.3-4.3
        C500.3,295.4,501.1,295.7,501.2,296.3z"/>
        <g>
        <path class="st5" d="M507.8,305.7l-0.8-0.4l-5.4,2.5c-0.2,0.1-0.4,0.3-0.4,0.6l-1,6c-0.1,0.6-0.9,0.8-1.3,0.4l-4.2-4.4
          c-0.2-0.2-0.4-0.3-0.7-0.2l-5.7,0.9l-0.4,0.8c-0.3,0.5,0.2,1.2,0.8,1.1l6-0.9c0.2,0,0.5,0,0.7,0.2l4.2,4.4
          c0.4,0.5,1.2,0.2,1.3-0.4l1-6c0-0.2,0.2-0.5,0.4-0.6l5.5-2.6C508.3,306.8,508.3,306,507.8,305.7z"/>
      </g>
        <path class="st6" d="M499.8,297.2c0,0-0.1,0.2-0.4,0.6c-0.3,0.3-0.6,0.7-1,1.1c-0.4,0.4-0.8,0.7-1.2,1c-0.3,0.2-0.6,0.4-0.6,0.4
        s0.1-0.2,0.4-0.6c0.3-0.3,0.6-0.7,1-1.1c0.4-0.4,0.8-0.7,1.2-1C499.6,297.3,499.8,297.2,499.8,297.2z"/>
        <path class="st6" d="M493.7,301.3c0,0-0.3,0-0.7,0c-0.4,0-1-0.1-1.5-0.2c-0.5-0.1-1.1-0.3-1.4-0.4c-0.4-0.2-0.6-0.3-0.6-0.3
        s0.3,0,0.7,0c0.4,0,1,0.1,1.5,0.2c0.5,0.1,1.1,0.3,1.4,0.4C493.5,301.2,493.7,301.3,493.7,301.3z"/>
        <path class="st6" d="M492.2,306.7c0,0-0.1,0.3-0.3,0.6c-0.2,0.4-0.5,0.8-0.8,1.3c-0.3,0.4-0.7,0.9-0.9,1.2
        c-0.3,0.3-0.5,0.5-0.5,0.5s0.1-0.3,0.3-0.6c0.2-0.4,0.5-0.8,0.8-1.3c0.3-0.4,0.7-0.9,0.9-1.2C491.9,306.9,492.2,306.7,492.2,306.7
        z"/>
    </g>
  </g>
    <g class="father-name father-name-1" :style="{opacity: name1 === ' ' ? '0' : '1'}">
    <g class="father-name-tag-1">
      <polygon class="st1" points="131.8,354.9 131.2,354.1 218.4,277.4 322.2,329.6 321.8,330.4 218.6,278.6"/>
      <rect x="126.2" y="337.3" transform="matrix(0.9918 -0.1275 0.1275 0.9918 -44.7912 32.1859)" class="st10"
            width="205.6" height="57.3"/>
      <circle class="st1" cx="131.5" cy="355.5" r="2"/>
      <circle class="st1" cx="321.5" cy="330.5" r="2"/>
      <g>
        <path class="st11" d="M153.5,395c0,0,1.8-0.2,4.9-0.7c3.1-0.4,7.6-1,12.9-1.7c5.4-0.7,11.6-1.5,18.3-2.3c6.7-0.8,13.9-1.7,21-2.5
          c7.2-0.8,14.3-1.6,21-2.4c6.7-0.7,13-1.4,18.4-2c5.4-0.6,9.9-1,13-1.3c3.1-0.3,4.9-0.5,4.9-0.5s-1.8,0.2-4.9,0.7
          c-3.1,0.4-7.6,1-12.9,1.7c-5.4,0.7-11.6,1.5-18.3,2.3c-6.7,0.8-13.9,1.7-21,2.5c-7.2,0.8-14.3,1.6-21,2.4c-6.7,0.7-13,1.4-18.4,2
          c-5.4,0.6-9.9,1-13,1.3C155.3,394.8,153.5,395,153.5,395z"/>
        <path class="st11" d="M186,387c0,0,1.8-0.2,4.9-0.7c3.1-0.4,7.6-1,12.9-1.7c5.4-0.7,11.6-1.5,18.3-2.3c6.7-0.8,13.9-1.7,21-2.5
          c7.2-0.8,14.3-1.6,21-2.4c6.7-0.7,13-1.4,18.4-2c5.4-0.6,9.9-1,13-1.3c3.1-0.3,4.9-0.5,4.9-0.5s-1.8,0.2-4.9,0.7
          c-3.1,0.4-7.6,1-12.9,1.7c-5.4,0.7-11.6,1.5-18.3,2.3c-6.7,0.8-13.9,1.7-21,2.5c-7.2,0.8-14.3,1.6-21,2.4c-6.7,0.7-13,1.4-18.4,2
          c-5.4,0.6-9.9,1-13,1.3C187.8,386.8,186,387,186,387z"/>
        <path class="st11" d="M170,353.6c0,0,1.2-0.2,3.2-0.5c2-0.3,4.9-0.7,8.4-1.2c3.5-0.4,7.5-1,11.8-1.5c4.3-0.5,9-1.1,13.6-1.7
          c4.6-0.5,9.3-1,13.6-1.5c4.3-0.5,8.4-0.9,11.9-1.2c3.5-0.4,6.4-0.6,8.4-0.8c2-0.2,3.2-0.3,3.2-0.3s-1.2,0.2-3.2,0.5
          c-2,0.3-4.9,0.7-8.4,1.2c-3.5,0.4-7.5,1-11.8,1.5c-4.3,0.5-9,1.1-13.6,1.7c-4.6,0.5-9.3,1-13.6,1.5c-4.3,0.5-8.4,0.9-11.9,1.2
          c-3.5,0.4-6.4,0.6-8.4,0.8C171.2,353.5,170,353.6,170,353.6z"/>
        <path class="st11" d="M144.3,368.8c0,0,0.8-0.1,2.1-0.4c1.3-0.2,3.3-0.5,5.6-0.9c2.3-0.3,5-0.8,7.9-1.1c2.9-0.4,6-0.8,9.1-1.2
          c3.1-0.4,6.2-0.7,9.1-1.1c2.9-0.3,5.6-0.6,7.9-0.8c2.3-0.2,4.3-0.4,5.6-0.5c1.4-0.1,2.1-0.2,2.1-0.2s-0.8,0.1-2.1,0.4
          c-1.3,0.2-3.3,0.5-5.6,0.9c-2.3,0.3-5,0.8-7.9,1.1c-2.9,0.4-6,0.8-9.1,1.2c-3.1,0.4-6.2,0.7-9.1,1.1c-2.9,0.3-5.6,0.6-7.9,0.8
          c-2.3,0.2-4.3,0.4-5.6,0.5C145.1,368.7,144.3,368.8,144.3,368.8z"/>
      </g>
      <g class="father-name-text father-name-text-1">
        <foreignObject x="126.2" y="337.3" transform="matrix(0.9918 -0.1275 0.1275 0.9918 -44.7912 32.1859)"
                       width="205.6" height="57.3">
          <div class="father-name-container">
            <name-container
              :text="name1"
              :chars-limit-one="16"
              :chars-limit-two="19"
              :chars-limit-three="22"
              size-three="0.6em"></name-container>
          </div>
        </foreignObject>
      </g>
    </g>
      <g class="father-name-star father-name-star-1">
      <path class="st4" d="M220.6,268.8l2.6,5.5c0.1,0.2,0.3,0.4,0.6,0.4l6,1c0.6,0.1,0.8,0.9,0.4,1.3l-4.4,4.2
        c-0.2,0.2-0.3,0.4-0.2,0.7l0.9,6c0.1,0.6-0.6,1.1-1.1,0.8l-5.3-2.9c-0.2-0.1-0.5-0.1-0.7,0l-5.4,2.7c-0.6,0.3-1.2-0.2-1.1-0.8
        l1.2-6c0-0.2,0-0.5-0.2-0.7l-4.3-4.3c-0.4-0.4-0.2-1.2,0.4-1.3l6-0.7c0.2,0,0.5-0.2,0.6-0.4l2.8-5.4
        C219.6,268.3,220.4,268.3,220.6,268.8z"/>
        <g>
        <path class="st5" d="M229.8,275.8l-0.9-0.2l-4.3,4c-0.2,0.2-0.3,0.4-0.2,0.7l0.9,6c0.1,0.6-0.6,1.1-1.1,0.8l-5.3-2.9
          c-0.2-0.1-0.5-0.1-0.7,0l-5.2,2.6l-0.2,0.9c-0.1,0.6,0.5,1.1,1.1,0.8l5.4-2.7c0.2-0.1,0.5-0.1,0.7,0l5.3,2.9
          c0.5,0.3,1.2-0.2,1.1-0.8l-0.9-6c0-0.2,0-0.5,0.2-0.7l4.4-4.2C230.6,276.6,230.4,275.9,229.8,275.8z"/>
      </g>
        <path class="st6" d="M219.6,270.1c0,0-0.1,0.3-0.2,0.7c-0.1,0.4-0.4,0.9-0.6,1.4c-0.3,0.5-0.6,0.9-0.8,1.3
        c-0.3,0.3-0.5,0.5-0.5,0.5s0.1-0.3,0.2-0.7c0.1-0.4,0.4-0.9,0.6-1.4c0.3-0.5,0.6-0.9,0.8-1.3C219.4,270.3,219.6,270.1,219.6,270.1
        z"/>
        <path class="st6" d="M215,275.9c0,0-0.3,0.1-0.7,0.2c-0.4,0.1-0.9,0.2-1.5,0.2c-0.5,0-1.1,0-1.5,0c-0.4,0-0.7-0.1-0.7-0.1
        s0.3-0.1,0.7-0.2c0.4-0.1,0.9-0.2,1.5-0.2c0.5,0,1.1,0,1.5,0C214.8,275.8,215,275.9,215,275.9z"/>
        <path class="st6" d="M215.2,281.5c0,0,0,0.3-0.1,0.7c-0.1,0.4-0.2,0.9-0.3,1.5c-0.2,0.5-0.4,1-0.5,1.4c-0.2,0.4-0.3,0.6-0.3,0.6
        s0-0.3,0.1-0.7c0.1-0.4,0.2-0.9,0.3-1.5c0.2-0.5,0.4-1,0.5-1.4C215,281.7,215.2,281.5,215.2,281.5z"/>
    </g>
  </g>
</svg>
</template>

<script>
import NameContainer from '@/components/NameContainer.vue'

export default {
  name: 'FatherNames',

  props: {
    name1: {
      type: String,
      default: ''
    },
    name2: {
      type: String,
      default: ''
    },
    name3: {
      type: String,
      default: ''
    }
  },

  components: { NameContainer }
}
</script>

<style scoped>
  .st0 {
    fill: #59BEC9;
  }

  .st1 {
    fill: #C800A1;
  }

  .st2 {
    fill: #FEDB00;
  }

  .st3 {
    fill: #D436B5;
  }

  .st4 {
    fill: #65C3CD;
  }

  .st5 {
    fill: #49B0BC;
  }

  .st6 {
    opacity: 0.5;
    fill: #FFFFFF;
  }

  .st7 {
    fill: #FFFFFF;
  }

  .st8 {
    font-family: 'Barlow';
  }

  .st9 {
    font-size: 18.5px;
    font-weight: 700;
  }

  .st10 {
    fill: #6CC24A;
  }

  .st11 {
    fill: #92D279;
  }

  .st12 {
    opacity: 0.5;
  }

  text {
    text-anchor: middle;
  }

  .father-name-container {
    font-family: 'Barlow';
    font-size: 18.5px;
    font-weight: 700;
    color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/FathersSlide/FatherNames.vue